import { UserSubscription } from "@/api/types";
import dayjs from "dayjs";

export function isItemDateEqualOrAfter(item: any) {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const itemYear = parseInt(item.year, 10);
  const itemMonth = parseInt(item.month, 10);

  if (itemYear > currentYear) {
    return true;
  } else if (itemYear === currentYear && itemMonth >= currentMonth) {
    return true;
  }

  return false;
}

export function isIssueWithinSubscription(
  issue: { month: string; year: string },
  subscriptions: { startDate: string; endDate: string }[]
): boolean {
  const issueMonth = parseInt(issue.month, 10);
  const issueYear = parseInt(issue.year, 10);
  const issueYM = issueYear * 100 + issueMonth;

  return subscriptions.some(({ startDate, endDate }) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const startYM = start.getFullYear() * 100 + (start.getMonth() + 1);
    const endYM = end.getFullYear() * 100 + (end.getMonth() + 1);

    return issueYM >= startYM && issueYM <= endYM;
  });
}

export function findActiveSubscription(
  subscriptions: UserSubscription[] | null
) {
  if (subscriptions && subscriptions.length) {
    const today = new Date();
    return subscriptions.find(
      (subscription: any) =>
        today >= new Date(subscription.startDate) &&
        today <= new Date(subscription.endDate)
    );
  } else return null;
}

export function getMonthYearDate(month: string, year: string) {
  const paddedMonth = month.padStart(2, "0");
  const dateString = `${year}-${paddedMonth}-01`;
  const date = dayjs(dateString);
  return new Date(date.format("YYYY-MM-DD"));
}
